import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { bankQueryRoot } from '../../../../shared/api/index.js';
import type { BankOperationPage, BankOperationsFilter } from '../../model/bank-operation.js';
import { getBankOperation } from '../requests/get-bank-operation.js';
import { getBankOperations } from '../requests/get-bank-operations.js';
import { getOperationLinkOptions } from '../requests/get-operation-link-options.js';

type OperationsPageParam = {
  cursor: string | null;
};

const CURRENT_YEAR = 'current';

const EVERY_MONTH = 'every';

const EVERY_CATEGORY = 'every';

const EVERY_MERCHANT = 'every';

const FIRST_PAGE: OperationsPageParam = { cursor: null };

const nextPageOf = (page: BankOperationPage): OperationsPageParam | undefined =>
  page.nextCursor === null ? undefined : { cursor: page.nextCursor };

export const bankTransactionQueries = {
  all: () => [...bankQueryRoot.all(), 'operations'] as const,
  lists: () => [...bankTransactionQueries.all(), 'list'] as const,
  list: (filter: BankOperationsFilter) =>
    infiniteQueryOptions({
      queryKey: [
        ...bankTransactionQueries.lists(),
        filter.year ?? CURRENT_YEAR,
        filter.month ?? EVERY_MONTH,
        filter.categoryId ?? EVERY_CATEGORY,
        filter.merchantKey ?? EVERY_MERCHANT,
      ] as const,
      queryFn: ({ pageParam, signal }) =>
        getBankOperations({ ...filter, cursor: pageParam.cursor }, signal),
      initialPageParam: FIRST_PAGE,
      getNextPageParam: nextPageOf,
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: [...bankTransactionQueries.all(), 'detail', id] as const,
      queryFn: ({ signal }) => getBankOperation(id, signal),
    }),
  linkOptions: (id: string) =>
    queryOptions({
      queryKey: [...bankTransactionQueries.all(), 'link-options', id] as const,
      queryFn: ({ signal }) => getOperationLinkOptions(id, signal),
    }),
};
